<template>
  <div id='bd-main'>
    <!-- 客服对话，显示客户信息等 -->
    <el-row>
      <el-col :span="16" id="middle-col">
        <bd-top></bd-top>
        <bd-message></bd-message>
        <bd-input v-if="showInput"></bd-input>
      </el-col>
      <el-col :span="8" id="right-col">
        <bd-right></bd-right>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { Layout } from 'vue-split-layout'
import BdTop from '@/components/dashboard/main/monitor/children/BdTop'
import BdMessage from '@/components/dashboard/main/monitor/children/BdMessage'
import BdInput from '@/components/dashboard/main/monitor/children/BdInput'
import BdRight from '@/components/dashboard/main/monitor/children/BdRight'
// import * as constants from '@/util/constants'

export default {
  name: 'bd-main',
  // components: { BdTop, BdMessage, BdInput, BdRight, Layout },
  components: { BdTop, BdMessage, BdInput, BdRight },
  data () {
    return {
      resize: true,
      splits: {
        dir: 'horizontal',
        first: 0,
        second: 1
      }
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentMonitorThread' ]),
    showInput () {
      // TODO: 根据是否插入会话判断
      return false
    }
  }
}
</script>

<style scoped>
#bd-main {
  height: 100%;
  overflow: hidden;
}
#bd-kefu {
  height: 100%;
}
.el-row {
  height: 100%;
}
.el-col {
  border-radius: 4px;
}
#left-col{
  height: 100%;
  border: 1px solid gainsboro;
}
#middle-col {
  height: 100%;
  border-top: 1px solid gainsboro;
  border-radius: 5px;
}
#right-col {
  height: 100%;
  border: 1px solid gainsboro;
}
</style>
